/* Brushed by Tess — theme behaviour */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------- utils */

  function formatMoney(cents) {
    var format = window.shopMoneyFormat || '€{{amount_with_comma_separator}}';
    var value = (cents / 100).toFixed(2);
    var withComma = value.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var noDecimals = Math.round(cents / 100)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDecimals)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
      .replace(/\{\{\s*amount\s*\}\}/g, value)
      .replace(/<[^>]*>/g, '');
  }

  /* --------------------------------------------------------------- reveal */

  function initReveal() {
    var els = document.querySelectorAll('.reveal');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) {
        el.classList.add('in');
      });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('in');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );
    els.forEach(function (el) {
      io.observe(el);
    });
  }

  /* ------------------------------------------------------------- parallax */

  function initParallax() {
    var els = Array.prototype.slice.call(document.querySelectorAll('[data-parallax]'));
    if (!els.length || reduceMotion) return;

    var raf = 0;
    function apply() {
      raf = 0;
      var y = window.scrollY;
      els.forEach(function (el) {
        var speed = parseFloat(el.getAttribute('data-parallax')) || 0;
        var zoom = el.hasAttribute('data-parallax-zoom');
        var offset = parseFloat(el.getAttribute('data-parallax-offset')) || 0;
        var shift = ((y - offset) * speed).toFixed(2);
        var scale = zoom ? ' scale(' + (1 + Math.min(y, 1200) * 0.00025).toFixed(4) + ')' : '';
        el.style.transform = 'translate3d(0, ' + shift + 'px, 0)' + scale;
      });
    }
    function onScroll() {
      if (!raf) raf = window.requestAnimationFrame(apply);
    }
    apply();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  }

  /* --------------------------------------------------------------- header */

  function initHeader() {
    var header = document.querySelector('[data-header]');
    if (!header) return;
    var isHome = header.hasAttribute('data-home');

    function onScroll() {
      var scrolled = window.scrollY > 24;
      header.classList.toggle('is-light', isHome && !scrolled);
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    var toggle = header.querySelector('[data-menu-toggle]');
    var mobileNav = header.querySelector('[data-mobile-nav]');
    if (toggle && mobileNav) {
      toggle.addEventListener('click', function () {
        var open = mobileNav.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        toggle.querySelectorAll('svg').forEach(function (svg) {
          svg.hidden = svg.hasAttribute('data-icon-close') ? !open : open;
        });
      });
    }
  }

  /* ----------------------------------------------------------- cart drawer */

  var CartDrawer = {
    el: null,

    init: function () {
      this.el = document.querySelector('[data-cart-drawer]');
      if (!this.el) return;
      var self = this;

      document.addEventListener('click', function (e) {
        var opener = e.target.closest('[data-cart-open]');
        if (opener) {
          e.preventDefault();
          self.open();
          return;
        }
        if (e.target.closest('[data-cart-close]')) {
          e.preventDefault();
          self.close();
        }
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') self.close();
      });

      this.el.addEventListener('click', function (e) {
        var minus = e.target.closest('[data-qty-minus]');
        var plus = e.target.closest('[data-qty-plus]');
        var remove = e.target.closest('[data-line-remove]');
        if (minus || plus || remove) {
          e.preventDefault();
          var node = (minus || plus || remove).closest('[data-line]');
          if (!node) return;
          var line = parseInt(node.getAttribute('data-line'), 10);
          var qty = parseInt(node.getAttribute('data-qty'), 10) || 1;
          var next = remove ? 0 : plus ? qty + 1 : Math.max(0, qty - 1);
          self.change(line, next);
        }
      });
    },

    open: function () {
      if (!this.el) return;
      this.el.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    },

    close: function () {
      if (!this.el) return;
      this.el.classList.remove('is-open');
      document.body.style.overflow = '';
    },

    change: function (line, quantity) {
      var self = this;
      fetch(window.routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          self.render(cart);
        })
        .catch(function () {
          window.location.href = window.routes.cart_url;
        });
    },

    refresh: function () {
      var self = this;
      fetch(window.routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          self.render(cart);
        });
    },

    render: function (cart) {
      var body = this.el.querySelector('[data-cart-body]');
      var foot = this.el.querySelector('[data-cart-foot]');
      var count = cart.item_count;

      document.querySelectorAll('[data-cart-count]').forEach(function (badge) {
        badge.textContent = count;
        badge.hidden = count === 0;
      });

      if (!body) return;

      if (!count) {
        body.innerHTML =
          '<div class="cart-empty"><div><p>Je winkelmand is leeg.</p>' +
          '<p class="text-muted" style="margin-top:.5rem;font-size:.875rem">Ontdek de beschikbare werken uit de studio.</p></div></div>';
        if (foot) foot.hidden = true;
        return;
      }

      if (foot) foot.hidden = false;

      var html = '';
      cart.items.forEach(function (item, i) {
        var img = item.image
          ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') + '" alt="" loading="lazy">'
          : '';
        var variant =
          item.variant_title && item.variant_title !== 'Default Title'
            ? '<p class="cart-line__variant">' + item.variant_title + '</p>'
            : '';
        html +=
          '<div class="cart-line" data-line="' + (i + 1) + '" data-qty="' + item.quantity + '">' +
          '<div class="cart-line__media">' + img + '</div>' +
          '<div>' +
          '<a href="' + item.url + '" class="cart-line__title">' + item.product_title + '</a>' +
          variant +
          '<div class="cart-line__foot">' +
          '<span class="qty">' +
          '<button type="button" data-qty-minus aria-label="Minder">&minus;</button>' +
          '<span>' + item.quantity + '</span>' +
          '<button type="button" data-qty-plus aria-label="Meer">+</button>' +
          '</span>' +
          '<span style="font-size:.875rem">' + formatMoney(item.final_line_price) + '</span>' +
          '</div>' +
          '<button type="button" class="cart-line__remove" data-line-remove style="margin-top:.5rem">Verwijderen</button>' +
          '</div></div>';
      });
      body.innerHTML = html;

      var total = this.el.querySelector('[data-cart-total]');
      if (total) total.textContent = formatMoney(cart.total_price);
    }
  };

  /* -------------------------------------------------------------- add form */

  function initAddToCart() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-add-to-cart]');
      if (!form) return;
      e.preventDefault();

      var button = form.querySelector('[type="submit"]');
      if (button) button.disabled = true;

      fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) {
          return r.json();
        })
        .then(function (res) {
          if (button) button.disabled = false;
          if (res.status) {
            window.location.href = form.action;
            return;
          }
          CartDrawer.refresh();
          CartDrawer.open();
        })
        .catch(function () {
          if (button) button.disabled = false;
          form.submit();
        });
    });
  }

  /* ----------------------------------------------------------------- tabs */

  function initTabs() {
    document.querySelectorAll('[data-tabs]').forEach(function (root) {
      var triggers = root.querySelectorAll('[data-tab-trigger]');
      var panels = root.querySelectorAll('[data-tab-panel]');
      triggers.forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          var name = trigger.getAttribute('data-tab-trigger');
          triggers.forEach(function (t) {
            t.classList.toggle('is-active', t === trigger);
            t.setAttribute('aria-selected', t === trigger ? 'true' : 'false');
          });
          panels.forEach(function (p) {
            p.hidden = p.getAttribute('data-tab-panel') !== name;
          });
        });
      });
    });
  }

  /* -------------------------------------------------------------- dialogs */

  function initDialogs() {
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-dialog-open]');
      if (opener) {
        var target = document.getElementById(opener.getAttribute('data-dialog-open'));
        if (target) target.classList.add('is-open');
        return;
      }
      if (e.target.closest('[data-dialog-close]') || e.target.matches('.dialog__overlay')) {
        var dialog = e.target.closest('.dialog');
        if (dialog) dialog.classList.remove('is-open');
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('.dialog.is-open').forEach(function (d) {
        d.classList.remove('is-open');
      });
    });
  }

  /* ------------------------------------------------------- product gallery */

  function initProductGallery() {
    document.querySelectorAll('[data-product-gallery]').forEach(function (root) {
      var main = root.querySelector('[data-gallery-main]');
      var thumbs = root.querySelectorAll('[data-gallery-thumb]');
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          if (main) {
            main.src = thumb.getAttribute('data-full');
            main.alt = thumb.getAttribute('data-alt') || '';
          }
          thumbs.forEach(function (t) {
            t.classList.toggle('is-active', t === thumb);
          });
        });
      });
    });
  }

  /* ------------------------------------------------------ variant selector */

  function initVariantPicker() {
    document.querySelectorAll('[data-variant-picker]').forEach(function (root) {
      var buttons = root.querySelectorAll('[data-variant]');
      var form = document.querySelector('[data-add-to-cart]');
      var input = form ? form.querySelector('[name="id"]') : null;
      var priceEl = document.querySelector('[data-variant-price]');
      var submit = form ? form.querySelector('[type="submit"]') : null;
      var submitLabel = submit ? submit.querySelector('[data-submit-label]') : null;

      buttons.forEach(function (button) {
        button.addEventListener('click', function () {
          if (button.classList.contains('is-unavailable')) return;
          buttons.forEach(function (b) {
            b.classList.toggle('is-active', b === button);
          });
          if (input) input.value = button.getAttribute('data-variant');
          if (priceEl) priceEl.textContent = button.getAttribute('data-price');
          var available = button.getAttribute('data-available') === 'true';
          if (submit) submit.disabled = !available;
          if (submitLabel) submitLabel.textContent = available ? 'In winkelwagen' : 'Verkocht';
        });
      });
    });
  }

  /* ----------------------------------------------------- portfolio slider */

  function initPortfolioSliders() {
    document.querySelectorAll('[data-slider]').forEach(function (root) {
      var track = root.querySelector('[data-slider-track]');
      var dots = root.querySelectorAll('[data-slider-dot]');
      var count = track ? track.children.length : 0;
      if (!track || count < 2) return;
      var idx = 0;

      function go(n) {
        idx = ((n % count) + count) % count;
        track.style.transform = 'translate3d(-' + idx * 100 + '%, 0, 0)';
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === idx);
        });
      }

      var prev = root.querySelector('[data-slider-prev]');
      var next = root.querySelector('[data-slider-next]');
      if (prev) prev.addEventListener('click', function () { go(idx - 1); });
      if (next) next.addEventListener('click', function () { go(idx + 1); });
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () { go(i); });
      });

      var startX = null;
      var deltaX = 0;
      root.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
        deltaX = 0;
      }, { passive: true });
      root.addEventListener('touchmove', function (e) {
        if (startX === null) return;
        deltaX = e.touches[0].clientX - startX;
      }, { passive: true });
      root.addEventListener('touchend', function () {
        if (Math.abs(deltaX) > 40) go(idx + (deltaX < 0 ? 1 : -1));
        startX = null;
        deltaX = 0;
      });

      go(0);
    });
  }

  /* ----------------------------------------------------------------- boot */

  function boot() {
    initReveal();
    initParallax();
    initHeader();
    CartDrawer.init();
    initAddToCart();
    initTabs();
    initDialogs();
    initProductGallery();
    initVariantPicker();
    initPortfolioSliders();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
